import {IDictionary, ISubNavigationItem} from "modules/types";
import {ProjectName, ViewPortVisibility} from "modules/enums";

const helpPageKey = "subheader.fifa.help";

const TRIVIA_SUB_NAVIGATION: ISubNavigationItem[] = [
	{
		name: "subheader.fifa.trivia_title",
		to: "/",
		href: "/trivia",
		projectName: ProjectName.Trivia,
		customClass: "trivia",
		subItems: [
			{
				name: "subheader.fifa.trivia_hub",
				to: "/",
				href: "/trivia",
				projectName: ProjectName.Trivia,
			},
			{
				name: helpPageKey,
				to: "/help",
				href: "/trivia/help",
				subItemsVisibility: ViewPortVisibility.MobileOnly,
				subItems: [],
				projectName: ProjectName.Trivia,
			},
		],
	},
];

const BRACKETS_SUB_NAVIGATION: ISubNavigationItem[] = [
	{
		name: "subheader.fifa.brackets_title",
		to: "/",
		href: "/content-bracket",
		projectName: ProjectName.Brackets,
		customClass: "brackets",
		subItems: [
			{
				name: "subheader.fifa.brackets_hub",
				to: "/",
				href: "/content-bracket",
				projectName: ProjectName.Brackets,
			},
			{
				name: helpPageKey,
				to: "/help",
				href: "/content-bracket/help",
				subItemsVisibility: ViewPortVisibility.MobileOnly,
				subItems: [],
				projectName: ProjectName.Brackets,
			},
		],
	},
];

const DRAW_PREDICTOR_SUB_NAVIGATION: ISubNavigationItem[] = [
	{
		name: "subheader.fifa.draw_predictor_title",
		to: "/",
		href: "/draw-predictor",
		projectName: ProjectName.Predictor,
		customClass: "draw_predictor",
		subItems: [
			{
				name: "subheader.fifa.draw_predictor_hub",
				to: "/",
				href: "/draw-predictor",
				projectName: ProjectName.Predictor,
			},
			{
				name: helpPageKey,
				to: "/help",
				href: "/draw-predictor/help",
				subItemsVisibility: ViewPortVisibility.MobileOnly,
				subItems: [],
				projectName: ProjectName.Predictor,
			},
		],
	},
];

export const SUB_NAVIGATION_ITEMS: ISubNavigationItem[] = [
	...TRIVIA_SUB_NAVIGATION,
	...BRACKETS_SUB_NAVIGATION,
	...DRAW_PREDICTOR_SUB_NAVIGATION,
];

export const TUTORIAL: IDictionary<boolean> = {
	CONTENT_BRACKET: true,
};
